import React, { EventHandler, FocusEvent } from "react";
import { Modal, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";

import { Button, CloseButton, ErrorMessage, RequiredMark } from "components";
import { required } from "validators/validation";

import styles from "./modal.module.scss";

type RejectWithReasonModalProps = {
	show: boolean;
	onHide: () => void;
	title: string;
	confirmButtonText: string;
	onSubmit: Function;
};

const RejectWithReasonModal = ({
	show = false,
	onHide,
	title = "Are you sure you want to reject the application?",
	confirmButtonText = "Reject",
	onSubmit,
}: RejectWithReasonModalProps) => {
	const {
		register,
		handleSubmit,

		formState: { errors },
	} = useForm({
		mode: "onChange",
	});

	const handleBlur: EventHandler<FocusEvent<HTMLTextAreaElement>> = e => {
		if (e.target.value) {
			e.target.value = e.target.value.trim();
		}
	};

	const handleSubmitForm = form => {
		onHide();
		onSubmit(form);
	};

	return (
		<Modal
			show={show}
			onHide={onHide}
			animation={false}
			centered
			className={styles.wrappRejectWithReasonModal}
		>
			<Modal.Header className="pb-0">
				<Modal.Title as="h6" className="text-center mb-3">
					{title}
				</Modal.Title>
				<CloseButton onClick={onHide} />
			</Modal.Header>
			<Modal.Body>
				<form onSubmit={handleSubmit(handleSubmitForm)}>
					<div className={styles.content}>
						<label htmlFor="reason">
							Reason
							<RequiredMark />
						</label>
						<Form.Control
							as="textarea"
							{...register("reason", {
								validate: {
									required,
								},
							})}
							onBlur={handleBlur}
							id="reason"
							placeholder="Enter Reason"
							rows={5}
							style={{ resize: "none" }}
							isInvalid={Boolean(errors?.reason)}
						/>
						<ErrorMessage field="reason" errors={errors} />
					</div>
					<div className={`${styles.wrappButtonsCenter} pb-5 pt-5`}>
						<Button
							onClick={onHide}
							value="Cancel"
							variant="outline-primary"
						/>
						<Button
							type="submit"
							value={confirmButtonText}
							variant="primary"
						/>
					</div>
				</form>
			</Modal.Body>
		</Modal>
	);
};

export default RejectWithReasonModal;
